import { connect } from 'react-redux';

import CreateGroupDialog from './CreateGroupDialog';
import {
  operations as groupOperations,
  selectors as groupSelectors,
} from '../../../../../store/groups';
import { classifyParticipants } from '../../../../../../core/selectors/classroom';

const mapStateToProps = (state) => {
  const setId = groupSelectors.createGroupDialogOpenFor(state);
  const set = setId ? groupSelectors.groupSet(state, setId) : null;
  const studentsWithNoGroup = set ? set.studentsWithNoGroup : [];

  return {
    setId,
    studentsWithNoGroup,
    classifyParticipants: classifyParticipants.bind(null, state),
    open: !!setId,
    saving: groupSelectors.isCreatingGroup(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadGroupAvatar: (file) =>
    dispatch(groupOperations.uploadGroupAvatar(file)),
  onSave: (classify, setId) => ({ participants, ...saveParams }) => {
    const { educators, students } = classify(participants);
    dispatch(
      groupOperations.addGroup({
        set: setId,
        educators,
        students,
        ...saveParams,
      })
    );
  },
  onClose: () => dispatch(groupOperations.closeAddGroup),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSave: dispatchProps.onSave(
    stateProps.classifyParticipants,
    stateProps.setId
  ),
  ...ownProps,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CreateGroupDialog);
